import React, { useState } from "react";
import * as Mui from "@mui/material";
import {
  Box,
  Typography,
  Divider,
  Card,
  CardContent,
  IconButton,
} from "@mui/material";
import { CustomButton } from "components/CustomComponents";
import { CustomTable } from "../Component/ShiftCategoryOptions";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { showToast } from "services/utils/Status";
import { customAPI } from "services/utils/CustomAPI";
import { boxStyleSx } from "../Component/ShiftCategoryOptions";
import { CustomButtonWithBorder } from "components/CustomComponents/CustomButton";
import { Close } from "@mui/icons-material";
import { chipColors } from "services/constants";

export const Preview = ({
  handleBack,
  basicInfoData,
  earningData,
  adjustmentData,
  deductionsData,
  onClose,
  closeEditScreen,
  reCallApi,
  isPreview,
  isEditScreen,
  setHandleLoader,
  setViewScreenData,
  isCreateScreen,
  clearAbsenceValues,
  sftPenaltyPolicy,
  onTaskResponse,
  editCategoryDetails,
  setIsViewPanelOpen,
}) => {
  const { setValue, watch, handleSubmit } = useForm();
  const { domain } = useSelector((state) => state.tokenReducer);

  const [openDialogConfimation, setOpenDialogConfimation] = useState(false);

  const [buttonLoader, setButtonLoader] = useState(false);
  const [formValues, setFormValues] = useState(null);

  const getBreakDeductionTypeLabel = (value) =>
    value === "shift_break" ? "Shift Break" : "Custom Duration";

  const renderPreviewValue = (
    value,
    { fontSize = 15, fontWeight, variant = null } = {},
  ) => {
    const isBooleanText = value === "Yes" || value === "No";

    if (isBooleanText) {
      return (
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            minWidth: 46,
            px: 1.2,
            py: 0.35,
            borderRadius: "8px",
            fontSize: variant === "body2" ? 12 : 13,
            fontWeight: 600,
            lineHeight: 1.2,
            color: value === "Yes" ? "#15803D" : "#B91C1C",
            backgroundColor: value === "Yes" ? "#DCFCE7" : "#FEE2E2",
            border: `1px solid ${value === "Yes" ? "#BBF7D0" : "#FECACA"}`,
          }}
        >
          {value}
        </Box>
      );
    }

    return (
      <Typography
        variant={variant || undefined}
        fontSize={fontSize}
        fontWeight={fontWeight || 500}
        color="#667084"
      >
        {value}
      </Typography>
    );
  };

  const renderPaymentFactorTable = (rows, title) => {
    if (!Array.isArray(rows) || rows.length === 0) return null;

    const configuredRows = rows.filter(
      (row) =>
        row &&
        (row.factor ||
          row.payment_factor ||
          row.work_band_name ||
          row.band_name ||
          row.start_time ||
          row.end_time),
    );
    if (configuredRows.length === 0) return null;

    return (
      <Box mt={2}>
        {title && (
          <Typography
            variant="body2"
            sx={{
              mb: 1,
              fontWeight: 600,
              color: "#101828",
            }}
          >
            {title}
          </Typography>
        )}
        <Mui.TableContainer
          component={Mui.Paper}
          sx={{
            borderRadius: 2,
            boxShadow: "none",
            border: "1px solid #e0e0e0",
            overflow: "hidden",
          }}
        >
          <Mui.Table size="small">
            <Mui.TableHead>
              <Mui.TableRow sx={{ backgroundColor: "#f7f7fb" }}>
                <Mui.TableCell sx={{ fontWeight: 600, textAlign: "left" }}>
                  Band
                </Mui.TableCell>
                <Mui.TableCell sx={{ fontWeight: 600, textAlign: "left" }}>
                  Factor
                </Mui.TableCell>
                <Mui.TableCell sx={{ fontWeight: 600, textAlign: "left" }}>
                  Start Time
                </Mui.TableCell>
                <Mui.TableCell sx={{ fontWeight: 600, textAlign: "left" }}>
                  End Time
                </Mui.TableCell>
              </Mui.TableRow>
            </Mui.TableHead>
            <Mui.TableBody>
              {configuredRows.map((row, index) => (
                <Mui.TableRow
                  key={`${row.work_band_name || row.band_name || row.overtime_band || index}-${index}`}
                >
                  <Mui.TableCell sx={{ textAlign: "left" }}>
                    {row.work_band_name ||
                      row.band_name ||
                      row.overtime_band ||
                      "-"}
                  </Mui.TableCell>
                  <Mui.TableCell sx={{ textAlign: "left" }}>
                    {row.factor ?? row.payment_factor ?? "-"}
                  </Mui.TableCell>
                  <Mui.TableCell sx={{ textAlign: "left" }}>
                    {row.start_time ?? "-"}
                  </Mui.TableCell>
                  <Mui.TableCell sx={{ textAlign: "left" }}>
                    {row.end_time ?? "-"}
                  </Mui.TableCell>
                </Mui.TableRow>
              ))}
            </Mui.TableBody>
          </Mui.Table>
        </Mui.TableContainer>
      </Box>
    );
  };

  const renderEquivalentHoursTable = (rows, title) => {
    if (!Array.isArray(rows) || rows.length === 0) return null;

    const configuredRows = rows.filter(
      (row) => row && (row.min_hours !== "" || row.credited_hours !== ""),
    );
    if (configuredRows.length === 0) return null;

    return (
      <Box mt={2}>
        {title && (
          <Typography variant="body2" color="text.secondary" mb={1}>
            {title}
          </Typography>
        )}
        <Mui.TableContainer
          component={Mui.Paper}
          sx={{
            borderRadius: 2,
            boxShadow: "none",
            border: "1px solid #e0e0e0",
            overflow: "hidden",
          }}
        >
          <Mui.Table size="small">
            <Mui.TableHead>
              <Mui.TableRow sx={{ backgroundColor: "#f7f7fb" }}>
                <Mui.TableCell sx={{ fontWeight: 600, textAlign: "center" }}>
                  Min hours
                </Mui.TableCell>
                <Mui.TableCell sx={{ fontWeight: 600, textAlign: "center" }}>
                  Credited hrs
                </Mui.TableCell>
              </Mui.TableRow>
            </Mui.TableHead>
            <Mui.TableBody>
              {configuredRows.map((row, index) => (
                <Mui.TableRow key={`${row.min_hours || index}-${index}`}>
                  <Mui.TableCell sx={{ textAlign: "center" }}>
                    {row.min_hours ?? "-"}
                  </Mui.TableCell>
                  <Mui.TableCell sx={{ textAlign: "center" }}>
                    {row.credited_hours ?? "-"}
                  </Mui.TableCell>
                </Mui.TableRow>
              ))}
            </Mui.TableBody>
          </Mui.Table>
        </Mui.TableContainer>
      </Box>
    );
  };

  const timeBoundBreakDeductFromLabels = {
    start_time: "Start",
    mid_time: "Mid",
    end_time: "End",
  };

  const timeBoundBreakDeductZoneApiValues = {
    start_time: "Start",
    mid_time: "Mid",
    end_time: "End",
  };

  const mapTimeBoundBreakRulesForApi = (rows) =>
    Array.isArray(rows)
      ? rows.map((row, index) => ({
          order: index +1,
          threshold_hours: row.hours,
          threshold_minutes: row.minutes,
          deduct_minutes: row.deduct_minutes,
          deduct_zone:
            timeBoundBreakDeductZoneApiValues[row.deduct_from] ||
            row.deduct_from,
        }))
      : [];

  const renderTimeBoundBreakTable = (rows, title) => {
    if (!Array.isArray(rows) || rows.length === 0) return null;

    const configuredRows = rows.filter(
      (row) => row && (row.hours || row.minutes || row.deduct_minutes),
    );
    if (configuredRows.length === 0) return null;

    return (
      <Box mt={2}>
        {title && (
          <Typography variant="body2" color="text.secondary" mb={1}>
            {title}
          </Typography>
        )}
        <Mui.TableContainer
          component={Mui.Paper}
          sx={{
            borderRadius: 2,
            boxShadow: "none",
            border: "1px solid #e0e0e0",
            overflow: "hidden",
          }}
        >
          <Mui.Table size="small">
            <Mui.TableHead>
              <Mui.TableRow sx={{ backgroundColor: "#f7f7fb" }}>
                <Mui.TableCell sx={{ fontWeight: 600, textAlign: "center" }}>
                  Rule
                </Mui.TableCell>
                <Mui.TableCell sx={{ fontWeight: 600, textAlign: "center" }}>
                  If Worked Hours Exceed
                </Mui.TableCell>
                <Mui.TableCell sx={{ fontWeight: 600, textAlign: "center" }}>
                  Deduct
                </Mui.TableCell>
                <Mui.TableCell sx={{ fontWeight: 600, textAlign: "center" }}>
                  With
                </Mui.TableCell>
              </Mui.TableRow>
            </Mui.TableHead>
            <Mui.TableBody>
              {configuredRows.map((row, index) => (
                <Mui.TableRow key={`time-bound-break-${index}`}>
                  <Mui.TableCell sx={{ textAlign: "center" }}>
                    Rule {index + 1}
                  </Mui.TableCell>
                  <Mui.TableCell sx={{ textAlign: "center" }}>
                    {row.hours ?? 0} hrs {row.minutes ?? 0} mins
                  </Mui.TableCell>
                  <Mui.TableCell sx={{ textAlign: "center" }}>
                    {row.deduct_minutes ?? 0} mins
                  </Mui.TableCell>
                  <Mui.TableCell sx={{ textAlign: "center" }}>
                    {timeBoundBreakDeductFromLabels[row.deduct_from] ||
                      row.deduct_from ||
                      "-"}
                  </Mui.TableCell>
                </Mui.TableRow>
              ))}
            </Mui.TableBody>
          </Mui.Table>
        </Mui.TableContainer>
      </Box>
    );
  };

  const renderWorkAdjustmentPreview = (bands, title) => {
    if (!Array.isArray(bands) || bands.length === 0) return null;

    const isDefaultBandRow = (row) =>
      ["attendance", "shift earning"].includes(
        (row?.band_name || "").trim().toLowerCase(),
      );

    const getWorkAdjustmentBandLabel = (row) =>
      isDefaultBandRow(row)
        ? "Shift Earning"
        : (row.band_name ?? row.factor ?? "-");

    return (
      <Box mt={2}>
        {title && (
          <Typography variant="body2" color="text.secondary" mb={1}>
            {title}
          </Typography>
        )}

        <Mui.TableContainer
          component={Mui.Paper}
          sx={{
            borderRadius: 2,
            boxShadow: "none",
            border: "1px solid #e0e0e0",
            overflow: "hidden",
          }}
        >
          <Mui.Table size="small">
            <Mui.TableHead>
              <Mui.TableRow sx={{ backgroundColor: "#f7f7fb" }}>
                <Mui.TableCell sx={{ fontWeight: 600, textAlign: "left" }}>
                  Band
                </Mui.TableCell>
                <Mui.TableCell sx={{ fontWeight: 600, textAlign: "left" }}>
                  Penalty Priority Assignment
                </Mui.TableCell>
              </Mui.TableRow>
            </Mui.TableHead>
            <Mui.TableBody>
              {bands.map((row, index) => (
                <Mui.TableRow
                  key={`${row.band_id || row.band_name || index}-${index}`}
                >
                  <Mui.TableCell sx={{ textAlign: "left", width: 180 }}>
                    <Box display="flex" alignItems="center" gap={1}>
                      <Typography sx={{ fontWeight: 700 }}>
                        {getWorkAdjustmentBandLabel(row)}
                      </Typography>
                    </Box>
                  </Mui.TableCell>
                  <Mui.TableCell sx={{ textAlign: "left" }}>
                    <Box sx={{ display: "flex", gap: 0.75, flexWrap: "wrap" }}>
                      {Array.isArray(row.priorities) &&
                      row.priorities.length > 0 ? (
                        row.priorities.map((p, i) => (
                          <Mui.Chip
                            key={`${p.name || p.priority}-${i}`}
                            size="small"
                            label={
                              <Box component="span">
                                <Typography
                                  component="span"
                                  sx={{
                                    fontWeight: 700,
                                    fontSize: 11,
                                    color:
                                      chipColors[p.name || p.priority]?.text ||
                                      "#2C2C2C",
                                  }}
                                >
                                  P{i + 1}
                                </Typography>

                                <Typography
                                  component="span"
                                  sx={{
                                    fontWeight: 600,
                                    fontSize: 11,
                                    color:
                                      chipColors[p.name || p.priority]?.text ||
                                      "#2C2C2C",
                                  }}
                                >
                                  {` · ${p.name || p.priority}`}
                                </Typography>
                              </Box>
                            }
                            sx={{
                              height: 26,
                              borderRadius: "6px",
                              backgroundColor:
                                chipColors[p.name || p.priority]?.bg || "#fff",
                              border: "1px solid #C8D8D0",
                              "& .MuiChip-label": {
                                px: 1,
                              },
                            }}
                            variant="outlined"
                          />
                        ))
                      ) : (
                        <Typography
                          sx={{ fontStyle: "italic", color: "#B2D4C0" }}
                        >
                          No penalties assigned
                        </Typography>
                      )}
                    </Box>
                  </Mui.TableCell>
                </Mui.TableRow>
              ))}
            </Mui.TableBody>
          </Mui.Table>
        </Mui.TableContainer>
      </Box>
    );
  };

  const mainFields = [
    {
      label: "Payment Based On",
      value: basicInfoData?.payment_based_on,
      table: basicInfoData?.payment_based_on === "Partial Shift Credit",
      tableData: basicInfoData?.rows,
      data:
        basicInfoData?.payment_based_on === "Partial Shift Credit" ? (
          <Typography variant="body2" color="text.secondary">
            Each additional{" "}
            <strong>{basicInfoData?.additional_percentage}</strong> percentage
            is counted as <strong>{basicInfoData?.shift_count}</strong> shift
          </Typography>
        ) : (
          ""
        ),
    },
    {
      label: "Payment hours calculation based on",
      value: basicInfoData?.is_include_sft_grade_sfts,
    },
    {
      label: "Allow Manual Break",
      value: basicInfoData?.is_manual_break_allowed ? "Yes" : "No",
      subFields: basicInfoData?.is_manual_break_allowed
        ? [
            {
              label: "Default Break Duration",
              value: `${basicInfoData?.manual_break_duration ?? 0} mins`,
            },
          ]
        : [],
    },
    {
      label: "Auto-Deduct Break Time",
      value: basicInfoData?.is_auto_deduct_break ? "Yes" : "No",
      subFields: basicInfoData?.is_auto_deduct_break
        ? [
            {
              label: "Break Deduction Rule",
              value: basicInfoData?.is_fixed_deduction
                ? "Fixed Deduction"
                : basicInfoData?.is_deduct_missed_breaks
                  ? "Break Not Taken"
                  : basicInfoData?.is_deduct_short_breaks
                    ? "Insufficient Break"
                    : "-",
            },
            ...(basicInfoData?.is_fixed_deduction
              ? [
                  {
                    label: "Fixed Deduction Method",
                    value: getBreakDeductionTypeLabel(
                      basicInfoData?.fixed_deduction_type,
                    ),
                  },
                  ...(basicInfoData?.fixed_deduction_type === "custom"
                    ? [
                        {
                          label: "Fixed Deduction Custom Duration",
                          value: `${
                            basicInfoData?.fixed_deduction_custom_duration ?? 0
                          } mins`,
                        },
                      ]
                    : []),
                ]
              : []),
            ...(basicInfoData?.is_deduct_missed_breaks
              ? [
                  {
                    label: "Break Not Taken Deduction Method",
                    value: getBreakDeductionTypeLabel(
                      basicInfoData?.missed_break_deduction_type,
                    ),
                  },
                  ...(basicInfoData?.missed_break_deduction_type === "custom"
                    ? [
                        {
                          label: "Break Not Taken Custom Duration",
                          value: `${
                            basicInfoData?.missed_break_custom_duration ?? 0
                          } mins`,
                        },
                      ]
                    : []),
                ]
              : []),
            ...(basicInfoData?.is_deduct_short_breaks
              ? [
                  {
                    label: "Insufficient Break Deduction Method",
                    value: getBreakDeductionTypeLabel(
                      basicInfoData?.short_break_deduction_type,
                    ),
                  },
                  ...(basicInfoData?.short_break_deduction_type === "custom"
                    ? [
                        {
                          label: "Insufficient Break Custom Duration",
                          value: `${
                            basicInfoData?.short_break_custom_duration ?? 0
                          } mins`,
                        },
                      ]
                    : []),
                ]
              : []),
            {
              label: "Deduction Applicability",
              value:
                basicInfoData?.break_deduction_applicability_type === "Hours"
                  ? "Hours"
                  : "Percentage",
            },
            ...(basicInfoData?.break_deduction_applicability_type !== "Hours"
              ? [
                  {
                    label: "Deduction Applicability Percentage",
                    value: `${
                      basicInfoData?.break_deduction_applicability_percentage ??
                      0
                    }%`,
                  },
                ]
              : []),
            ...(basicInfoData?.break_deduction_applicability_type === "Hours"
              ? [
                  {
                    label: "Time-Bound Break Deductions",
                    value: basicInfoData?.is_break_time_bound_break_deduction_allowed
                      ? "Yes"
                      : "No",
                  },
                ]
              : []),
          ]
        : [],
      data:
        basicInfoData?.is_auto_deduct_break &&
        basicInfoData?.break_deduction_applicability_type === "Hours" &&
        basicInfoData?.is_break_time_bound_break_deduction_allowed
          ? renderTimeBoundBreakTable(
              basicInfoData?.break_time_bound_deduction_configurations,
              "Time-bound break deduction configuration",
            )
          : null,
    },

    {
      label: "Is OverTime Allowed",
      value: earningData?.is_overtime_allowed ? "Yes" : "No",
      subFields: earningData?.is_overtime_allowed
        ? [
            {
              label: "OT work preauthorization",
              value:
                earningData?.ot_work_preauthorization === "Automatic"
                  ? "Automatic"
                  : "Manual",
            },
            ...(earningData?.ot_work_preauthorization === "Automatic"
              ? [
                  {
                    label: "OT timing preference",
                    value:
                      earningData?.ot_timing_privilege === "Only Before"
                        ? "Before Shift"
                        : earningData?.ot_timing_privilege === "Only After"
                          ? "After shift"
                          : "Both",
                  },
                ]
              : []),

            {
              label: "Calculation based on",
              value: earningData?.calculation_based_on,
            },
            ...(earningData?.calculation_based_on === "Hours"
              ? [
                  {
                    label: "Payment based on",
                    value:
                      earningData?.is_ot_payment_based_on === "Amount"
                        ? "Fixed Amount"
                        : earningData?.is_ot_payment_based_on,
                  },
                ]
              : []),
            {
              label: "Is OT pay added to payroll by default",
              value: earningData?.is_ot_pay_by_default ? "Yes" : "No",
            },
            ...(earningData?.calculation_based_on === "Hours"
              ? [
                  {
                    label: "Is Overtime Band Factor Applied",
                    value: earningData?.is_allow_payment_factor_for_ot
                      ? "Yes"
                      : "No",
                  },
                ]
              : []),
            ...(earningData?.calculation_based_on === "Hours" &&
            earningData?.is_allow_payment_factor_for_ot
              ? [
                  {
                    label: "Add remaining (unrounded) hours to 1.0 OT",
                    value: earningData?.is_add_remaining_ot_to_base_factor
                      ? "Yes"
                      : "No",
                  },
                ]
              : []),
          ]
        : [],
      table:
        earningData?.calculation_based_on === "Shift" &&
        earningData?.is_overtime_allowed,
      tableData: earningData?.rows,
      data:
        earningData?.is_overtime_allowed &&
        earningData?.calculation_based_on === "Hours" ? (
          <Box>
            {earningData?.is_ot_payment_based_on === "Attendance" ? (
              <Box>
                <Typography variant="body2" color="text.secondary" mb={1}>
                  The threshold limit for overtime is{" "}
                  <strong>{earningData?.minimum_ot_consideration}</strong> mins
                  will be considered as{" "}
                  <strong>{earningData?.minutes_for_consideration}</strong> mins{" "}
                  <strong>{earningData?.attendance_deduct_type}</strong>
                </Typography>

                <Typography variant="body2" color="text.secondary">
                  After that, every additional{" "}
                  <strong>{earningData?.additional_ot}</strong> mins will be
                  considered as{" "}
                  <strong>
                    {earningData?.additional_minutes_for_consideration}{" "}
                  </strong>
                  <strong>{earningData?.attendance_deduct_type}</strong>
                </Typography>
                {earningData?.is_allow_payment_factor_for_ot &&
                  renderPaymentFactorTable(
                    earningData?.ot_payment_factor_configurations,
                    "Overtime payment factor configuration",
                  )}
              </Box>
            ) : earningData?.is_ot_payment_based_on === "Equivalent Hours" ? (
              <Box>
                <Typography variant="body2" color="text.secondary" mb={1}>
                  Overtime equivalent hours are credited using the configured
                  hour mapping.
                </Typography>
                {renderEquivalentHoursTable(
                  earningData?.ot_equivalent_hours_configurations,
                  "Equivalent hours configuration",
                )}
                <Typography variant="body2" color="text.secondary" mt={1}>
                  After that, every additional{" "}
                  <strong>
                    {earningData?.equivalent_hours_additional_minutes}
                  </strong>{" "}
                  mins will be considered as{" "}
                  <strong>{earningData?.equivalent_hours_ot_minutes}</strong>{" "}
                  mins OT
                </Typography>
                {earningData?.is_allow_payment_factor_for_ot &&
                  renderPaymentFactorTable(
                    earningData?.ot_payment_factor_configurations,
                    "Overtime payment factor configuration",
                  )}
              </Box>
            ) : (
              <Box>
                <Box mb={1}>
                  <Typography variant="body2" color="text.secondary">
                    The threshold limit for overtime is{" "}
                    <strong>
                      {earningData?.ot_fixed_amount_thereshold_limit}
                    </strong>{" "}
                    mins with an amount payable of{" "}
                    <strong>{earningData?.ot_fixed_amount_payable}</strong>{" "}
                    <strong>{earningData?.fixed_amount_deduct_type}</strong>
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="body2" color="text.secondary">
                    For every additional{" "}
                    <strong>
                      {earningData?.ot_fixed_amount_additional_mins}
                    </strong>{" "}
                    mins an additional{" "}
                    <strong>
                      {earningData?.ot_fixed_amount_additional_payable}{" "}
                    </strong>
                    will be payable{" "}
                    <strong>{earningData?.fixed_amount_deduct_type}</strong>
                  </Typography>
                </Box>
              </Box>
            )}
          </Box>
        ) : earningData?.is_overtime_allowed &&
          earningData?.calculation_based_on === "Shift" ? (
          <Box>
            <Typography variant="body2" color="text.secondary">
              Each additional{" "}
              <strong>{earningData?.deduct_additional_percentage}</strong>{" "}
              percentage is counted as{" "}
              <strong>{earningData?.deduct_shift_count}</strong> shift
            </Typography>
          </Box>
        ) : (
          ""
        ),
    },
  ];

  const formatWeekOffRuleType = (ruleType) => {
    switch (ruleType) {
      case "Before":
        return "Before the week-off only";
      case "After":
        return "After the week-off only";
      case "Both":
        return "Both before and after the week-off";
      case "Any":
        return "Either before or after the week-off";
      default:
        return "-";
    }
  };

  const formatHolidayRuleType = (ruleType) => {
    switch (ruleType) {
      case "Before":
        return "Before the holiday only";
      case "After":
        return "After the holiday only";
      case "Both":
        return "Both before and after the holiday";
      case "Any":
        return "Either before or after the holiday";
      default:
        return "-";
    }
  };

  const absenceWorkAdjustmentBands =
    adjustmentData?.absence_work_adjustment_priority_bands ?? [];

  const adjustmentFields = [
    {
      label: "Is On Duty Allowed",
      value: adjustmentData?.is_onduty_allowed ? "Yes" : "No",
    },
    {
      label: "Is Permission Allowed",
      value: adjustmentData?.is_permission_allowed ? "Yes" : "No",
      subFields: adjustmentData?.is_permission_allowed
        ? [
            {
              label: "Include in working hours",
              value: adjustmentData?.is_permission_include_working_hour
                ? "Yes"
                : "No",
            },

            ...(adjustmentData?.is_permission_include_working_hour
              ? [
                  {
                    label: "Is permission hours deducted from priority penalty",
                    value:
                      adjustmentData?.is_permission_hours_included_in_the_priority_deduction
                        ? "Yes"
                        : "No",
                  },
                ]
              : []),
          ]
        : [],
    },
    {
      label: "Week-off Sandwich Leave",
      value: adjustmentData?.is_weekoff_sandwich_leave ? "Yes" : "No",
      subFields: adjustmentData?.is_weekoff_sandwich_leave
        ? [
            {
              label: "Applied rule",
              value: formatWeekOffRuleType(adjustmentData?.absence_rule_type),
            },
          ]
        : [],
    },
    {
      label: "Holiday Sandwich Leave",
      value: adjustmentData?.is_holiday_sandwich_leave ? "Yes" : "No",
      subFields: adjustmentData?.is_holiday_sandwich_leave
        ? [
            {
              label: "Applied rule",
              value: formatHolidayRuleType(
                adjustmentData?.absence_rule_type_for_holiday,
              ),
            },
          ]
        : [],
    },
    {
      label: "Is Comp Off Allowed",
      value: adjustmentData?.is_compoff_allowed ? "Yes" : "No",
    },
    {
      label: "Work Adjustment Priority",
      value: adjustmentData?.is_work_adjustment_priority ? "Yes" : "No",
      data:
        adjustmentData?.is_work_adjustment_priority &&
        absenceWorkAdjustmentBands.length > 0
          ? renderWorkAdjustmentPreview(absenceWorkAdjustmentBands, "")
          : null,
    },
  ];

  //weekoff fields

  const weekoffFields = [
    {
      label: "Is Weekoff Paid",
      value: earningData?.is_weekoff_paid ? "Yes" : "No",
    },
    {
      label: "As per weekday calculations",
      value: earningData?.as_per_week_day_for_week_off ? "Yes" : "No",
    },
    {
      label: "Payment for weekoff day attendance",
      value: earningData?.payment_for_week_off_attendance ? "Yes" : "No",
      indent: true,
      subFields: earningData?.payment_for_week_off_attendance
        ? [
            {
              label: "Weekoff work Preauthorization",
              value:
                earningData?.week_off_work_pre_authorization === "Automatic"
                  ? "Automatic"
                  : "Manual",
            },
            {
              label: "Calculation based on",
              value: earningData?.weekoff_calculation_based_on,
            },
            ...(earningData?.weekoff_calculation_based_on === "Hours"
              ? [
                  {
                    label: "Payment based on",
                    value:
                      earningData?.is_weekoff_payment_based_on === "Amount"
                        ? "Fixed Amount"
                        : "Attendance",
                  },
                ]
              : []),
            {
              label: "Is Weekoff pay added to payroll by default",
              value: earningData?.is_weekoff_pay_by_default ? "Yes" : "No",
            },
            ...(earningData?.weekoff_calculation_based_on === "Hours"
              ? [
                  {
                    label: "Is Weekoff Band Factor Applied",
                    value: earningData?.is_allow_payment_factor_for_weekoff
                      ? "Yes"
                      : "No",
                  },
                ]
              : []),
            ...(earningData?.weekoff_calculation_based_on === "Hours" &&
            earningData?.is_allow_payment_factor_for_weekoff
              ? [
                  {
                    label: "Add remaining (unrounded) hours to 1.0 Weekoff",
                    value: earningData?.is_add_remaining_weekoff_to_base_factor
                      ? "Yes"
                      : "No",
                  },
                ]
              : []),
          ]
        : [],
      table:
        earningData?.weekoff_calculation_based_on === "Shift" &&
        earningData?.payment_for_week_off_attendance,
      tableData: earningData?.weekoffRows,
      data:
        earningData?.payment_for_week_off_attendance &&
        earningData?.weekoff_calculation_based_on === "Hours" ? (
          <Box>
            {earningData?.is_weekoff_payment_based_on === "Attendance" ? (
              <Box>
                <Typography variant="body2" color="text.secondary" mb={1}>
                  The threshold limit for weekoff is{" "}
                  <strong>{earningData?.weekoff_thres_hold_limit}</strong> mins
                  will be considered as{" "}
                  <strong>
                    {earningData?.weekoff_thres_hold_consideration}
                  </strong>{" "}
                  mins <strong>Per Day</strong>
                </Typography>

                <Typography variant="body2" color="text.secondary">
                  After that, every additional{" "}
                  <strong>{earningData?.weekoff_additional_thres_hold}</strong>{" "}
                  mins will be considered as{" "}
                  <strong>
                    {
                      earningData?.weekoff_additional_thres_hold_consideration
                    }{" "}
                  </strong>
                  <strong>Per Day</strong>
                </Typography>
                {earningData?.is_allow_payment_factor_for_weekoff &&
                  renderPaymentFactorTable(
                    earningData?.weekoff_payment_factor_configurations,
                    "Weekoff payment factor configuration",
                  )}
              </Box>
            ) : (
              <Box>
                <Box mb={1}>
                  <Typography variant="body2" color="text.secondary">
                    The threshold limit for overtime is{" "}
                    <strong>
                      {
                        earningData?.weekoff_fixed_amount_thres_hold_consideration
                      }
                    </strong>{" "}
                    mins with an amount payable of{" "}
                    <strong>
                      {earningData?.weekoff_fixed_amount_thres_hold}
                    </strong>{" "}
                    <strong>Per Day</strong>
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="body2" color="text.secondary">
                    For every additional{" "}
                    <strong>
                      {
                        earningData?.weekoff_fixed_amount_additional_thres_hold_consideration
                      }
                    </strong>{" "}
                    mins an additional{" "}
                    <strong>
                      {
                        earningData?.weekoff_fixed_amount_additional_thres_hold
                      }{" "}
                    </strong>
                    will be payable <strong>Per Day</strong>
                  </Typography>
                </Box>
              </Box>
            )}
          </Box>
        ) : earningData?.payment_for_week_off_attendance &&
          earningData?.weekoff_calculation_based_on === "Shift" ? (
          <Box>
            <Typography variant="body2" color="text.secondary">
              Each additional{" "}
              <strong>
                {earningData?.weekoff_partial_shift_additional_percentage}
              </strong>{" "}
              percentage is counted as{" "}
              <strong>{earningData?.weekoff_partial_shift_count}</strong> shift
            </Typography>
          </Box>
        ) : (
          ""
        ),
    },
    {
      label: "Time-Bound Break Deductions",
      value: earningData?.is_weekoff_time_bound_break_deduction_allowed
        ? "Yes"
        : "No",
      data: earningData?.is_weekoff_time_bound_break_deduction_allowed
        ? renderTimeBoundBreakTable(
            earningData?.weekoff_time_bound_break_deduction_configurations,
            "Time-bound break deduction configuration",
          )
        : null,
    },
  ];

  //holidayfields
  const holidayFields = [
    {
      label: "Is Holiday Paid",
      value: earningData?.is_holiday_paid ? "Yes" : "No",
    },
    {
      label: "As per weekday calculations",
      value: earningData?.as_per_week_day_for_holiday ? "Yes" : "No",
    },
    {
      label: "Payment for holiday day attendance",
      value: earningData?.is_payment_for_holiday_day_attendance ? "Yes" : "No",
      indent: true,
      subFields: earningData?.is_payment_for_holiday_day_attendance
        ? [
            {
              label: "Holiday work Preauthorization",
              value:
                earningData?.holiday_work_preauthorization === "Automatic"
                  ? "Automatic"
                  : "Manual",
            },
            {
              label: "Calculation based on",
              value: earningData?.holiday_calculation_based_on,
            },
            ...(earningData?.holiday_calculation_based_on === "Hours"
              ? [
                  {
                    label: "Payment based on",
                    value:
                      earningData?.is_holiday_payment_based_on === "Amount"
                        ? "Fixed Amount"
                        : "Attendance",
                  },
                ]
              : []),
            {
              label: "Is Holiday pay added to payroll by default",
              value: earningData?.holiday_added_payroll_default ? "Yes" : "No",
            },

            ...(earningData?.holiday_calculation_based_on === "Hours"
              ? [
                  {
                    label: "Is Holiday Band Factor Applied",
                    value: earningData?.is_allow_payment_factor_for_holiday
                      ? "Yes"
                      : "No",
                  },
                ]
              : []),
            ...(earningData?.holiday_calculation_based_on === "Hours" &&
            earningData?.is_allow_payment_factor_for_holiday
              ? [
                  {
                    label: "Add remaining (unrounded) hours to 1.0 Holiday",
                    value: earningData?.is_add_remaining_holiday_to_base_factor
                      ? "Yes"
                      : "No",
                  },
                ]
              : []),
          ]
        : [],
      table:
        earningData?.holiday_calculation_based_on === "Shift" &&
        earningData?.is_payment_for_holiday_day_attendance,
      tableData: earningData?.holidayRows,
      data:
        earningData?.is_payment_for_holiday_day_attendance &&
        earningData?.holiday_calculation_based_on === "Hours" ? (
          <Box>
            {earningData?.is_holiday_payment_based_on === "Attendance" ? (
              <Box>
                <Typography variant="body2" color="text.secondary" mb={1}>
                  The threshold limit for overtime is{" "}
                  <strong>{earningData?.holiday_thres_hold_limit}</strong> mins
                  will be considered as{" "}
                  <strong>
                    {earningData?.holiday_thres_hold_consideration}
                  </strong>{" "}
                  mins <strong>Per Day</strong>
                </Typography>

                <Typography variant="body2" color="text.secondary">
                  After that, every additional{" "}
                  <strong>{earningData?.holiday_additional_thres_hold}</strong>{" "}
                  mins will be considered as{" "}
                  <strong>
                    {
                      earningData?.holiday_additional_thres_hold_consideration
                    }{" "}
                  </strong>
                  <strong>Per Day</strong>
                </Typography>
                {earningData?.is_allow_payment_factor_for_holiday &&
                  renderPaymentFactorTable(
                    earningData?.holiday_payment_factor_configurations,
                    "Holiday payment factor configuration",
                  )}
              </Box>
            ) : (
              <Box>
                <Box mb={1}>
                  <Typography variant="body2" color="text.secondary">
                    The threshold limit for overtime is{" "}
                    <strong>
                      {earningData?.holiday_fixed_amount_thres_hold}
                    </strong>{" "}
                    mins with an amount payable of{" "}
                    <strong>{earningData?.holiday_fixed_amount_payable}</strong>{" "}
                    <strong>Per Day</strong>
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="body2" color="text.secondary">
                    For every additional{" "}
                    <strong>
                      {earningData?.holiday_fixed_amount_additional_mins}
                    </strong>{" "}
                    mins an additional{" "}
                    <strong>
                      {
                        earningData?.holiday_fixed_amount_additional_payable
                      }{" "}
                    </strong>
                    will be payable <strong>Per Day</strong>
                  </Typography>
                </Box>
              </Box>
            )}
          </Box>
        ) : earningData?.is_payment_for_holiday_day_attendance &&
          earningData?.holiday_calculation_based_on === "Shift" ? (
          <Box>
            <Typography variant="body2" color="text.secondary">
              Each additional{" "}
              <strong>
                {earningData?.holiday_partial_shift_additional_percentage}
              </strong>{" "}
              percentage is counted as{" "}
              <strong>{earningData?.holiday_partial_shift_count}</strong> shift
            </Typography>
          </Box>
        ) : (
          ""
        ),
    },
    {
      label: "Time-Bound Break Deductions",
      value: earningData?.is_holiday_time_bound_break_deduction_allowed
        ? "Yes"
        : "No",
      data: earningData?.is_holiday_time_bound_break_deduction_allowed
        ? renderTimeBoundBreakTable(
            earningData?.holiday_time_bound_break_deduction_configurations,
            "Time-bound break deduction configuration",
          )
        : null,
    },
  ];

  //absence paid

  const absenceFields = earningData?.is_absence_paid
    ? [
        {
          label: "Is Absence Paid",
          value: clearAbsenceValues
            ? "No"
            : earningData?.is_absence_paid
              ? "Yes"
              : "No",
        },
        !clearAbsenceValues && {
          label:
            earningData?.absent_payment_based_on === "Paid"
              ? "Absence is paid in full, no salary deduction"
              : "Absence is partly paid based on a payment factor",
          value:
            earningData?.absent_payment_based_on === "Paid"
              ? "Paid"
              : `Payment Factor: ${
                  earningData?.partial_payment_factor ?? "N/A"
                }`,
          indent: true,
        },
      ].filter(Boolean)
    : [
        {
          label: "Is Absence Paid",
          value: earningData?.is_absence_paid ? "Yes" : "No",
        },
      ];

  //penalty fields

  const penaltyFields =
    deductionsData?.is_apply_sft_penalty_policy && !sftPenaltyPolicy
      ? [
          {
            label: "Apply Shift Penalty Policy",
            value: deductionsData?.is_apply_sft_penalty_policy ? "Yes" : "No",
          },

          {
            label: "Penalty based on",
            value: deductionsData?.penalty_options,
            indent: true,
          },

          ...(deductionsData?.penalty_options === "hours"
            ? [
                {
                  label: "Deduction calculation based on",
                  value: deductionsData?.dedctions_options,
                  indent: true,
                },
              ]
            : []),
          {
            data: (
              <Box>
                {deductionsData?.penalty_options === "hours" &&
                deductionsData?.dedctions_options === "Attendance" ? (
                  <>
                    <Box mb={1}>
                      <Typography variant="body2" color="text.secondary">
                        For the first{" "}
                        <strong>
                          {deductionsData?.attendance_first_mins ?? "N/A"}
                        </strong>{" "}
                        mins of late arrival or early exit,a{" "}
                        <strong>
                          {deductionsData?.attendance_late_exit ?? "N/A"}
                        </strong>{" "}
                        mins deduction will be applied{" "}
                        <strong>
                          {deductionsData?.deductions_attendance_deduct_type ??
                            "N/A"}
                        </strong>
                      </Typography>
                    </Box>

                    <Box>
                      <Typography variant="body2" color="text.secondary">
                        After that for every additional{" "}
                        <strong>
                          {deductionsData?.attendance_initial_mins ?? "N/A"}
                        </strong>{" "}
                        mins of early/late, a{" "}
                        <strong>
                          {deductionsData?.attendance_additional_mins ?? "N/A"}
                        </strong>{" "}
                        mins deduction will be applied
                      </Typography>
                    </Box>
                  </>
                ) : deductionsData?.penalty_options === "hours" &&
                  deductionsData?.dedctions_options === "Amount" ? (
                  <>
                    <Box mb={1}>
                      <Typography variant="body2" color="text.secondary">
                        If an employee is late arrival or early exit by{" "}
                        <strong>
                          {deductionsData?.fixed_amount_early_late ?? "N/A"}
                        </strong>{" "}
                        mins{" "}
                        <strong>
                          {deductionsData?.fixed_amount_deduct_amount ?? "N/A"}
                        </strong>{" "}
                        amount will be deducted{" "}
                        <strong>
                          {deductionsData?.deductions_fixed_amount_deduct_type ??
                            "N/A"}
                        </strong>
                      </Typography>
                    </Box>
                    <Box>
                      <Typography variant="body2" color="text.secondary">
                        For every additional{" "}
                        <strong>
                          {deductionsData?.fixed_amount_extra_mins ?? "N/A"}
                        </strong>{" "}
                        mins an additional{" "}
                        <strong>
                          {deductionsData?.fixed_amount_early_late_deduct_amt ??
                            "N/A"}
                        </strong>{" "}
                        will be deductable{" "}
                        <strong>
                          {deductionsData?.deductions_fixed_amount_deduct_type ??
                            "N/A"}
                        </strong>
                      </Typography>
                    </Box>
                  </>
                ) : deductionsData?.penalty_options === "shift" ? (
                  <>
                    <Box mb={1}>
                      <Typography variant="body2" color="text.secondary">
                        If an employee is late arrival or early exit by{" "}
                        <strong>
                          {deductionsData?.sft_penalty_early_late_mins ?? "N/A"}
                        </strong>{" "}
                        mins{" "}
                        <strong>
                          {deductionsData?.sft_penalty_deduct ?? "N/A"}
                        </strong>{" "}
                        shift will be deducted
                      </Typography>
                    </Box>

                    <Box>
                      <Typography variant="body2" color="text.secondary">
                        For every additional{" "}
                        <strong>
                          {deductionsData?.sft_penalty_additional_mins ?? "N/A"}
                        </strong>{" "}
                        mins, early or late, another{" "}
                        <strong>
                          {deductionsData?.sft_penalty_sft_deduct ?? "N/A"}
                        </strong>{" "}
                        shift will be deducted
                      </Typography>
                    </Box>
                  </>
                ) : (
                  <>
                    <Box mb={1}>
                      <Typography variant="body2" color="text.secondary">
                        If an employee breaches the late entry/early exit
                        threshold{" "}
                        <strong>
                          {deductionsData?.sft_penalty_count_thershold ?? "N/A"}
                        </strong>{" "}
                        times,{" "}
                        <strong>
                          {deductionsData?.sft_penalty_count_deduct ?? "N/A"}
                        </strong>{" "}
                        shift will be deducted
                      </Typography>
                    </Box>
                    <Box>
                      <Typography variant="body2" color="text.secondary">
                        For every additional breach of{" "}
                        <strong>
                          {deductionsData?.sft_penalty_count_additional_mins ??
                            "N/A"}
                        </strong>
                        the deduction will be{" "}
                        <strong>
                          {deductionsData?.sft_penalty_count_sft_deduct ??
                            "N/A"}
                        </strong>{" "}
                        shift
                      </Typography>
                    </Box>
                  </>
                )}
              </Box>
            ),
          },
        ]
      : [
          {
            label: "Apply Shift Penalty Policy",
            value: deductionsData?.is_apply_sft_penalty_policy ? "Yes" : "No",
          },
        ];

  // breakpenalty policy

  const breakPenaltyFields =
    deductionsData?.is_apply_break_penalty_policy && !sftPenaltyPolicy
      ? [
          {
            label: "Apply Break penalty policy",
            value: deductionsData?.is_apply_break_penalty_policy ? "Yes" : "No",
          },

          {
            label: "Break",
            value: deductionsData?.is_deduct_break_penalty_policy,
            indent: true,
          },

          {
            data: (
              <Box>
                <Box mb={1}>
                  <Typography variant="body2" color="text.secondary">
                    An extra break of up to{" "}
                    <strong>
                      {deductionsData?.extra_break_minutes ?? "N/A"}
                    </strong>{" "}
                    minutes will result in a{" "}
                    <strong>{deductionsData?.break_deduction ?? "N/A"}</strong>{" "}
                    minute deduction{" "}
                    <strong>
                      {deductionsData?.break_penalty_deduct_type ?? "N/A"}
                    </strong>
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="body2" color="text.secondary">
                    For every additional{" "}
                    <strong>
                      {deductionsData?.additional_break_minutes ?? "N/A"}
                    </strong>{" "}
                    minutes beyond that, another{" "}
                    <strong>
                      {deductionsData?.additional_break_deduction ?? "N/A"}
                    </strong>{" "}
                    minute deduction will be applied{" "}
                    <strong>
                      {deductionsData?.break_penalty_deduct_type ?? "N/A"}
                    </strong>
                  </Typography>
                </Box>
              </Box>
            ),
          },
        ]
      : [
          {
            label: "Apply Break penalty policy",
            value: deductionsData?.is_apply_break_penalty_policy ? "Yes" : "No",
          },
        ];

  //deduct salary

  const deductSalaryFields = deductionsData?.deduct_salary_for_absence
    ? [
        {
          label: "Deduct salary for absence",
          value: deductionsData?.deduct_salary_for_absence ? "Yes" : "No",
        },

        {
          label: "Consider unpaid leave for absence penalty",
          value: deductionsData?.consider_unpaid_leave_for_absent_penalty
            ? "Yes"
            : "No",
        },

        {
          data: (
            <Box>
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" color="text.secondary">
                  If an employee is absent for{" "}
                  <strong>{deductionsData?.deduction ?? "N/A"}</strong> day,
                  deduct an additional{" "}
                  <strong>
                    {deductionsData?.additional_deduction ?? "N/A"}
                  </strong>{" "}
                  day as penalty.
                </Typography>
              </Box>
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" color="text.secondary">
                  For every extra{" "}
                  <strong>{deductionsData?.extra_deduction ?? "N/A"}</strong>{" "}
                  day of absence, deduct{" "}
                  <strong>
                    {deductionsData?.extra_additional_deduction ?? "N/A"}
                  </strong>{" "}
                  day as penalty.
                </Typography>
              </Box>
            </Box>
          ),
        },

        {
          label: "Reduce Overtime Incentive for Absence Penalty",
          value: deductionsData?.is_absence_penalty_band_hours_paid
            ? "Yes"
            : "No",
        },
      ]
    : [
        {
          label: "Deduct salary for absence",
          value: deductionsData?.deduct_salary_for_absence ? "Yes" : "No",
        },
      ];

  // leave to absent conversion

  const leaveToAbsentConversionFields = deductionsData?.is_leave_to_absent_convert
    ? [
        {
          label: "Leave / Absence Penalty",
          value: deductionsData?.is_leave_to_absent_convert ? "Yes" : "No",
        },
        {
          label: "Threshold (Days)",
          value: deductionsData?.is_leave_to_absent_convert_count ?? "N/A",
        },
        {
          label: "Penalty Value",
          value: deductionsData?.apply_penalty_count
            ? `${deductionsData.apply_penalty_count} Leave Day(s)`
            : "N/A",
        },
      ]
    : [
        {
          label: "Leave / Absence Penalty",
          value: deductionsData?.is_leave_to_absent_convert ? "Yes" : "No",
        },
      ];

  const onSubmit = (data) => {
    setFormValues(data);
    if (isEditScreen) {
      setOpenDialogConfimation(true);
    } else {
      updateShiftCategory(data);
    }
  };

  const updateShiftCategory = async (data) => {
    setValue("button_loader", true);
    const payload = {
      name: basicInfoData?.sft_category_name.trim(),
      ot_allowed: earningData?.is_overtime_allowed,
      shift_penalty_deduction: deductionsData?.is_apply_sft_penalty_policy,
      break_penalty_deduction: deductionsData?.is_apply_break_penalty_policy,
      is_paid_week_off: earningData?.is_weekoff_paid,
      as_per_week_day_for_week_off: earningData?.as_per_week_day_for_week_off,
      as_per_week_day_for_holiday: earningData?.as_per_week_day_for_holiday,
      is_paid_holiday: earningData?.is_holiday_paid,
      payment_based_on: basicInfoData?.payment_based_on,
      other_shift_grade_shifts_choice: basicInfoData?.is_include_sft_grade_sfts,
      payment_allowed_partial_shift_work: basicInfoData?.is_partial_shift_work,
      is_manual_break_allowed: basicInfoData?.is_manual_break_allowed,
      is_auto_deduct_break: basicInfoData?.is_auto_deduct_break,
      is_time_bount_break_deductions:
        basicInfoData?.is_auto_deduct_break &&
        basicInfoData?.break_deduction_applicability_type === "Hours"
          ? basicInfoData?.is_break_time_bound_break_deduction_allowed
          : false,
      shift_time_boundary_rules:
        basicInfoData?.is_auto_deduct_break &&
        basicInfoData?.break_deduction_applicability_type === "Hours" &&
        basicInfoData?.is_break_time_bound_break_deduction_allowed
          ? mapTimeBoundBreakRulesForApi(
              basicInfoData?.break_time_bound_deduction_configurations,
            )
          : [],
      break_application_policy: {
        manual_break_duration: basicInfoData?.is_manual_break_allowed
          ? Number(basicInfoData?.manual_break_duration)
          : 0,
        is_fixed_deduction: basicInfoData?.is_auto_deduct_break
          ? basicInfoData?.is_fixed_deduction
          : false,
        fixed_deduction_type:
          basicInfoData?.is_auto_deduct_break &&
          basicInfoData?.is_fixed_deduction
            ? basicInfoData?.fixed_deduction_type
            : "",
        fixed_deduction_custom_duration:
          basicInfoData?.is_auto_deduct_break &&
          basicInfoData?.is_fixed_deduction &&
          basicInfoData?.fixed_deduction_type === "custom"
            ? Number(basicInfoData?.fixed_deduction_custom_duration)
            : 0,
        is_deduct_missed_breaks: basicInfoData?.is_auto_deduct_break
          ? basicInfoData?.is_deduct_missed_breaks
          : false,
        missed_break_deduction_type:
          basicInfoData?.is_auto_deduct_break &&
          basicInfoData?.is_deduct_missed_breaks
            ? basicInfoData?.missed_break_deduction_type
            : "",
        missed_break_custom_duration:
          basicInfoData?.is_auto_deduct_break &&
          basicInfoData?.is_deduct_missed_breaks &&
          basicInfoData?.missed_break_deduction_type === "custom"
            ? Number(basicInfoData?.missed_break_custom_duration)
            : 0,
        is_deduct_short_breaks: basicInfoData?.is_auto_deduct_break
          ? basicInfoData?.is_deduct_short_breaks
          : false,
        short_break_deduction_type:
          basicInfoData?.is_auto_deduct_break &&
          basicInfoData?.is_deduct_short_breaks
            ? basicInfoData?.short_break_deduction_type
            : "",
        short_break_custom_duration:
          basicInfoData?.is_auto_deduct_break &&
          basicInfoData?.is_deduct_short_breaks &&
          basicInfoData?.short_break_deduction_type === "custom"
            ? Number(basicInfoData?.short_break_custom_duration)
            : 0,
        break_deduction_applicability_percentage:
          basicInfoData?.is_auto_deduct_break
            ? Number(basicInfoData?.break_deduction_applicability_percentage)
            : 0,
        deduction_applicability: basicInfoData?.is_auto_deduct_break
          ? basicInfoData?.break_deduction_applicability_type || "Percentage"
          : "Percentage",
      },
      is_onduty_allowed: adjustmentData?.is_onduty_allowed,
      is_permission_allowed: adjustmentData?.is_permission_allowed,
      is_permission_include_working_hour:
        adjustmentData?.is_permission_include_working_hour,
      is_permission_hours_included_in_the_priority_deduction:
        adjustmentData?.is_permission_hours_included_in_the_priority_deduction,
      is_compoff_allowed: adjustmentData?.is_compoff_allowed,
      is_absence_paid: clearAbsenceValues
        ? false
        : earningData?.is_absence_paid,
      deduct_salary_for_absence: deductionsData?.deduct_salary_for_absence,
      consider_unpaid_leave_for_absent_penalty:
        deductionsData?.consider_unpaid_leave_for_absent_penalty,
      is_absence_penalty_band_hours_paid:
        deductionsData?.is_absence_penalty_band_hours_paid,
      is_leave_to_absent_convert: deductionsData?.is_leave_to_absent_convert,
      ...(deductionsData?.is_leave_to_absent_convert && {
        is_leave_to_absent_convert_count: Number(
          deductionsData?.is_leave_to_absent_convert_count,
        ),
        apply_penalty_count: Number(
          deductionsData?.apply_penalty_count,
        ),
      }),
      is_weekoff_sandwich_leave: adjustmentData?.is_weekoff_sandwich_leave,
      is_holiday_sandwich_leave: adjustmentData?.is_holiday_sandwich_leave,

      ...(adjustmentData?.is_weekoff_sandwich_leave && {
        is_weekoff_sandwich_leave_data: {
          absence_rule_type: adjustmentData?.absence_rule_type,
        },
      }),

      ...(adjustmentData?.is_holiday_sandwich_leave && {
        is_holiday_sandwich_leave_data: {
          absence_rule_type: adjustmentData?.absence_rule_type_for_holiday,
        },
      }),

      weekoff_category: [
        {
          payment_for_week_off_attendance:
            earningData?.payment_for_week_off_attendance,
          payment_based_on: earningData?.is_weekoff_payment_based_on,
          fixed_amount: null,
          week_off_payment_factor: earningData?.week_off_payment_factor,
          week_off_work_pre_authorization:
            earningData?.week_off_work_pre_authorization,
          calculation_based_on: earningData?.weekoff_calculation_based_on,
          added_payroll_default: earningData?.is_weekoff_pay_by_default,
          consideration: "Per Day",
          is_time_bount_break_deductions:
            earningData?.is_weekoff_time_bound_break_deduction_allowed,
          weekoff_time_boundary_rules: mapTimeBoundBreakRulesForApi(
            earningData?.weekoff_time_bound_break_deduction_configurations,
          ),
          ...(earningData?.weekoff_calculation_based_on === "Hours" &&
            earningData?.is_weekoff_payment_based_on === "Attendance" && {
              minimum_week_off_consideration_minutes:
                earningData?.weekoff_thres_hold_limit,
              minutes_for_consideration:
                earningData?.weekoff_thres_hold_consideration,
              additional_week_off_consideration_minutes:
                earningData?.weekoff_additional_thres_hold,
              additional_minutes_for_consideration:
                earningData?.weekoff_additional_thres_hold_consideration,
              consideration: "Per Day",
              attendance_payment_factor:
                earningData?.is_allow_payment_factor_for_weekoff,
              add_remaining_minutes_to_payroll:
                earningData?.is_add_remaining_weekoff_to_base_factor,
              work_bands:
                earningData?.weekoff_payment_factor_configurations?.map(
                  (row) => ({
                    band_id: row?.overtime_band ?? row?.band_id,
                    work_band_name: row.band_name ?? "",
                    factor: parseFloat(row.factor),
                    start_time: row.start_time,
                    end_time: row.end_time,
                  }),
                ) ?? [],
            }),
          ...(earningData?.is_weekoff_payment_based_on === "Amount" && {
            consideration: "Per Day",
            threshold_week_off_consideration_minutes:
              earningData?.weekoff_fixed_amount_thres_hold,
            week_off_amount_payable:
              earningData?.weekoff_fixed_amount_thres_hold_consideration,
            additional_threshold_week_off_consideration_minutes:
              earningData?.weekoff_fixed_amount_additional_thres_hold,
            additional_week_off_amount_payable:
              earningData?.weekoff_fixed_amount_additional_thres_hold_consideration,
          }),

          week_off_compensation_rules: [
            {
              additional_percentage:
                earningData?.weekoff_partial_shift_additional_percentage,
              shift_per_day: earningData?.weekoff_partial_shift_count,
              week_off_percentage_ranges: earningData?.weekoffRows?.map(
                (row) => ({
                  work_min_percentage: parseFloat(row.work_min_percentage),
                  count_as_shift: parseFloat(row.count_as_shift),
                }),
              ),
            },
          ],
        },
      ],
      holiday_category: [
        {
          payment_for_holiday_attendance:
            earningData?.is_payment_for_holiday_day_attendance,
          payment_based_on: earningData?.is_holiday_payment_based_on,
          fixed_amount: null,
          holiday_payment_factor: earningData?.holiday_sft_payment_factor,
          holiday_work_pre_authorization:
            earningData?.holiday_work_preauthorization,
          calculation_based_on: earningData?.holiday_calculation_based_on,
          added_payroll_default: earningData?.holiday_added_payroll_default,
          consideration: "Per Day",
          is_time_bount_break_deductions:
            earningData?.is_holiday_time_bound_break_deduction_allowed,
          holiday_time_boundary_rules: mapTimeBoundBreakRulesForApi(
            earningData?.holiday_time_bound_break_deduction_configurations,
          ),
          ...(earningData?.holiday_calculation_based_on === "Hours" &&
            earningData?.is_holiday_payment_based_on === "Attendance" && {
              minimum_holiday_consideration_minutes:
                earningData?.holiday_thres_hold_limit,
              minutes_for_consideration:
                earningData?.holiday_thres_hold_consideration,
              additional_holiday_consideration_minutes:
                earningData?.holiday_additional_thres_hold,
              additional_minutes_for_consideration:
                earningData?.holiday_additional_thres_hold_consideration,
              consideration: "Per Day",
              attendance_payment_factor:
                earningData?.is_allow_payment_factor_for_holiday,
              add_remaining_minutes_to_payroll:
                earningData?.is_add_remaining_holiday_to_base_factor,
              work_bands:
                earningData?.holiday_payment_factor_configurations?.map(
                  (row) => ({
                    band_id: row?.overtime_band ?? row?.band_id,
                    work_band_name: row.work_band_name ?? row.band_name ?? "",
                    factor: parseFloat(row.factor),
                    start_time: row.start_time,
                    end_time: row.end_time,
                  }),
                ) ?? [],
            }),
          ...(earningData?.is_holiday_payment_based_on === "Amount" && {
            consideration: "Per Day",
            threshold_holiday_consideration_minutes:
              earningData?.holiday_fixed_amount_thres_hold,
            holiday_amount_payable: earningData?.holiday_fixed_amount_payable,
            additional_threshold_holiday_consideration_minutes:
              earningData?.holiday_fixed_amount_additional_mins,
            additional_holiday_amount_payable:
              earningData?.holiday_fixed_amount_additional_payable,
          }),

          holiday_compensation_rules: [
            {
              additional_percentage:
                earningData?.holiday_partial_shift_additional_percentage,
              shift_per_day: earningData?.holiday_partial_shift_count,
              holiday_percentage_ranges: earningData?.holidayRows?.map(
                (row) => ({
                  work_min_percentage: parseFloat(row.work_min_percentage),
                  count_as_shift: parseFloat(row.count_as_shift),
                }),
              ),
            },
          ],
        },
      ],

      ...(basicInfoData?.payment_based_on === "Partial Shift Credit" && {
        compensation_rules: [
          {
            additional_percentage: basicInfoData?.additional_percentage,
            shift_per_day: basicInfoData?.shift_count,
            shift_percentage_ranges: basicInfoData?.rows?.map((row) => ({
              work_min_percentage: parseFloat(row.work_min_percentage),
              count_as_shift: parseFloat(row.count_as_shift),
            })),
          },
        ],
      }),

      ...(earningData?.is_overtime_allowed && {
        overtime_policies: [
          {
            ot_work_pre_authorization: earningData?.ot_work_preauthorization,
            ...(earningData?.calculation_based_on === "Hours" && {
              payment_based_on: earningData?.is_ot_payment_based_on,
            }),
            ...(earningData?.ot_work_preauthorization === "Automatic" && {
              ot_time_privilage: earningData?.ot_timing_privilege,
            }),
            calculation_based_on: earningData?.calculation_based_on,
            payment_factor:
              earningData?.calculation_based_on === "Hours" &&
              (earningData?.is_ot_payment_based_on === "Attendance" ||
                earningData?.is_ot_payment_based_on === "Equivalent Hours")
                ? 1
                : earningData?.ot_sft_payment_factor,
            added_payroll_default: earningData?.is_ot_pay_by_default,
            ...(earningData?.calculation_based_on === "Hours" &&
              earningData?.is_ot_payment_based_on === "Attendance" && {
                minimum_ot_consideration_minutes:
                  earningData?.minimum_ot_consideration,
                minutes_for_consideration:
                  earningData?.minutes_for_consideration,
                additional_ot_consideration_minutes: earningData?.additional_ot,
                additional_minutes_for_consideration:
                  earningData?.additional_minutes_for_consideration,
                consideration: earningData?.attendance_deduct_type,
                attendance_payment_factor:
                  earningData?.is_allow_payment_factor_for_ot,
                add_remaining_minutes_to_payroll:
                  earningData?.is_add_remaining_ot_to_base_factor,
                work_bands:
                  earningData?.ot_payment_factor_configurations?.map((row) => ({
                    band_id: row?.overtime_band ?? row?.band_id,
                    work_band_name: row.work_band_name ?? row.band_name ?? "",
                    factor: parseFloat(row.factor),
                    start_time: row.start_time,
                    end_time: row.end_time,
                  })) ?? [],
              }),
            ...(earningData?.calculation_based_on === "Hours" &&
              earningData?.is_ot_payment_based_on === "Equivalent Hours" && {
                equivalent_hours_additional_minutes:
                  earningData?.equivalent_hours_additional_minutes,
                equivalent_hours_ot_minutes:
                  earningData?.equivalent_hours_ot_minutes,
                equivalent_hours:
                  earningData?.ot_equivalent_hours_configurations?.map(
                    (row) => ({
                      ...(row?.id != null && { id: row.id }),
                      min_hours: row.min_hours,
                      credited_hours: row.credited_hours,
                    }),
                  ) ?? [],
                attendance_payment_factor:
                  earningData?.is_allow_payment_factor_for_ot,
                add_remaining_minutes_to_payroll:
                  earningData?.is_add_remaining_ot_to_base_factor,
                work_bands:
                  earningData?.ot_payment_factor_configurations?.map((row) => ({
                    band_id: row?.overtime_band ?? row?.band_id,
                    work_band_name: row.work_band_name ?? row.band_name ?? "",
                    factor: parseFloat(row.factor),
                    start_time: row.start_time,
                    end_time: row.end_time,
                  })) ?? [],
              }),
            ...(earningData?.is_ot_payment_based_on === "Amount" && {
              consideration: earningData?.fixed_amount_deduct_type,
              threshold_ot_consideration_minutes:
                earningData?.ot_fixed_amount_thereshold_limit,
              ot_amount_payable: earningData?.ot_fixed_amount_payable,
              additional_threshold_ot_consideration_minutes:
                earningData?.ot_fixed_amount_additional_mins,
              additional_ot_amount_payable:
                earningData?.ot_fixed_amount_additional_payable,
            }),

            ...(earningData?.calculation_based_on === "Shift" && {
              overtime_compensation_rules: [
                {
                  additional_percentage:
                    earningData?.deduct_additional_percentage,
                  shift_per_day: earningData?.deduct_shift_count,
                  ot_percentage_ranges: earningData?.rows.map((row) => ({
                    work_min_percentage: parseFloat(row.work_min_percentage),
                    count_as_shift: parseFloat(row.count_as_shift),
                  })),
                },
              ],
            }),
          },
        ],
      }),

      ...(deductionsData?.is_apply_break_penalty_policy && {
        break_penalty_policies: [
          {
            extra_break_minutes: deductionsData?.extra_break_minutes,
            break_deduction: deductionsData?.break_deduction,
            additional_break_minutes: deductionsData?.additional_break_minutes,
            additional_break_deduction:
              deductionsData?.additional_break_deduction,
            apply_always:
              deductionsData?.is_deduct_break_penalty_policy === "always",
            deficit_working_hours:
              deductionsData?.is_deduct_break_penalty_policy === "deficit",
            consideration: deductionsData?.break_penalty_deduct_type,
          },
        ],
      }),

      ...(deductionsData?.is_apply_sft_penalty_policy && {
        deduction_policies: [
          {
            penalty_based_on: deductionsData?.penalty_options,
            deduction_based_on: deductionsData?.dedctions_options,
            ...(deductionsData?.dedctions_options === "Attendance" &&
              deductionsData?.penalty_options === "hours" && {
                payment_factor: 1,
              }),

            ...(deductionsData?.dedctions_options === "Attendance" &&
              deductionsData?.penalty_options === "hours" && {
                attendance_deductions: [
                  {
                    first_initial: deductionsData?.attendance_first_mins,
                    early_late: deductionsData?.attendance_late_exit,
                    deduction_type:
                      deductionsData?.deductions_attendance_deduct_type,
                    after_initial: deductionsData?.attendance_initial_mins,
                    additional_early_late:
                      deductionsData?.attendance_additional_mins,
                  },
                ],
              }),

            ...(deductionsData?.dedctions_options === "Amount" &&
              deductionsData?.penalty_options === "hours" && {
                fixed_amount_deductions: [
                  {
                    fixed_amount_early_late:
                      deductionsData?.fixed_amount_early_late,
                    fixed_amount_deduction:
                      deductionsData?.fixed_amount_deduct_amount,
                    deduction_type:
                      deductionsData?.deductions_fixed_amount_deduct_type,
                    fixed_amount_after_initial:
                      deductionsData?.fixed_amount_extra_mins,
                    fixed_amount_additional_deduction:
                      deductionsData?.fixed_amount_early_late_deduct_amt,
                  },
                ],
              }),
            ...(deductionsData?.penalty_options === "shift" && {
              shift_based_deductions: [
                {
                  shift_early_late: deductionsData?.sft_penalty_early_late_mins,
                  shift_deduction: deductionsData?.sft_penalty_deduct,
                  shift_after_initial:
                    deductionsData?.sft_penalty_additional_mins,
                  shift_additional_deduction:
                    deductionsData?.sft_penalty_sft_deduct,
                },
              ],
            }),

            ...(deductionsData?.penalty_options === "count" && {
              count_based_deductions: [
                {
                  count_early_late: deductionsData?.sft_penalty_count_thershold,
                  count_deduction: deductionsData?.sft_penalty_count_deduct,
                  count_after_initial:
                    deductionsData?.sft_penalty_count_additional_mins,
                  count_additional_deduction:
                    deductionsData?.sft_penalty_count_sft_deduct,
                },
              ],
            }),
          },
        ],
      }),

      ...(earningData?.is_absence_paid &&
        !clearAbsenceValues && {
          absent_earnings: {
            absent_payment_based_on: earningData?.absent_payment_based_on,
            ...(earningData?.absent_payment_based_on === "Partially Paid" && {
              partial_payment_factor: earningData?.partial_payment_factor,
            }),
          },
        }),

      ...(deductionsData?.deduct_salary_for_absence && {
        absent_deductions: {
          deduction: deductionsData?.deduction,
          additional_deduction: deductionsData?.additional_deduction,
          extra_deduction: deductionsData?.extra_deduction,
          extra_additional_deduction:
            deductionsData?.extra_additional_deduction,
        },
      }),

      is_work_adjustment_priority:
        adjustmentData?.is_work_adjustment_priority ?? false,

      ...(adjustmentData?.is_work_adjustment_priority &&
        absenceWorkAdjustmentBands.length > 0 && {
          work_adjustment_priorities: absenceWorkAdjustmentBands.map(
            (band, bandIndex) => ({
              band_id: band.band_id,
              order: band.band_order ?? band.order ?? bandIndex + 1,
              penalty_assignments: Array.isArray(band.priorities)
                ? band.priorities.map((penalty, penaltyIndex) => ({
                    penalty_type: penalty.name,
                    deduction_order: penaltyIndex + 1,
                  }))
                : [],
            }),
          ),
        }),
    };
    const url = isEditScreen
      ? `${domain}administration/shiftroster/shiftrota/shift-categories/${basicInfoData?.sftCategoryId}/`
      : `${domain}administration/shiftroster/shiftrota/shift-categories`;
    const method = isEditScreen ? "PUT" : "POST";
    try {
      const response = await customAPI(url, method, payload);

      if (response.ok) {
        const result = await response.responseDetails;
        showToast("success", response.responseDetails?.message);

        if (isEditScreen) {
          // Close edit screen
          closeEditScreen && closeEditScreen();
          // Close view panel
          setIsViewPanelOpen && setIsViewPanelOpen(false);
        } else {
          onClose && onClose();
        }

        // Call onTaskResponse if provided (for WebSocket etc.)
        if (onTaskResponse) {
          onTaskResponse(result);
        } else {
          // Just refresh data
          reCallApi(true);
        }

        setOpenDialogConfimation(false);
        setButtonLoader(false);
        setValue("button_loader", false);

        // Set handle loader for main component
        setHandleLoader && setHandleLoader(true);
      } else {
        setButtonLoader(false);
        setValue("button_loader", false);
      }
    } catch (error) {
      console.error("Update error:", error);
      setButtonLoader(false);
      setValue("button_loader", false);
    }
  };

  const handleDeactivateDialogBox = () => {
    setOpenDialogConfimation(false);
    setButtonLoader(false);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            flexGrow: 1,
            overflow: "auto",
            p: 2,
          }}
          component="form"
          onSubmit={handleSubmit(onSubmit)}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2.5,
            }}
          >
            {!isPreview && <Divider sx={{ my: 3 }} />}
            <Typography
              fontWeight="bold"
              color="black"
              fontSize={16}
              textAlign="center"
            >
              {basicInfoData?.sft_category_name}
            </Typography>

            <Card variant="outlined" sx={{ borderColor: "#00000040" }}>
              <CardContent sx={{ p: 3 }}>
                {mainFields.map((field, index) => (
                  <React.Fragment key={field.label}>
                    <Box display="flex" justifyContent="space-between" py={1.5}>
                      <Typography fontSize={15} fontWeight={500}>
                        {field.label}
                      </Typography>
                      {renderPreviewValue(field.value)}
                    </Box>
                    {field.subFields && field.subFields.length > 0 && (
                      <Box mt={3}>
                        {field.subFields.map((sub, i) => (
                          <Box
                            key={i}
                            display="flex"
                            alignItems="flex-start"
                            pl={3}
                            gap={1}
                            mb={2}
                          >
                            <Box
                              sx={{
                                width: 6,
                                height: 6,
                                bgcolor: "#09bd71",
                                borderRadius: "2px",
                                mt: 0.5,
                              }}
                            />
                            <Box
                              display="flex"
                              justifyContent="space-between"
                              flex={1}
                            >
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                {sub.label}
                              </Typography>
                              {renderPreviewValue(sub.value, {
                                variant: "body2",
                              })}
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    )}
                    {field?.table && <CustomTable data={field?.tableData} />}
                    <Box
                      mt={1}
                      ml={3}
                      mb={2}
                      display="flex"
                      alignItems="flex-start"
                    >
                      <Box sx={{ width: "100%" }}>{field.data}</Box>
                    </Box>

                    {index < mainFields.length - 1 && (
                      <Divider sx={{ mt: 2 }} />
                    )}
                  </React.Fragment>
                ))}

                <Divider sx={{ my: 1 }} />
                {/* Weekoff Fields */}
                {weekoffFields.map((field) => (
                  <React.Fragment key={field.label}>
                    <Box display="flex" justifyContent="space-between" py={0.5}>
                      <Typography fontSize={15} fontWeight={500}>
                        {field.label}
                      </Typography>
                      {renderPreviewValue(field.value)}
                    </Box>
                    {field.subFields && field.subFields.length > 0 && (
                      <Box mt={3}>
                        {field.subFields.map((sub, i) => (
                          <Box
                            key={i}
                            display="flex"
                            alignItems="flex-start"
                            pl={3}
                            gap={1}
                            mb={2}
                          >
                            <Box
                              sx={{
                                width: 6,
                                height: 6,
                                bgcolor: "#09bd71",
                                borderRadius: "2px",
                                mt: 0.5,
                              }}
                            />
                            <Box
                              display="flex"
                              justifyContent="space-between"
                              flex={1}
                            >
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                {sub.label}
                              </Typography>
                              {renderPreviewValue(sub.value, {
                                variant: "body2",
                              })}
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    )}
                    {field?.table && <CustomTable data={field?.tableData} />}
                    <Box
                      mt={1}
                      ml={3}
                      mb={2}
                      display="flex"
                      alignItems="flex-start"
                    >
                      <Box sx={{ width: "100%" }}>{field.data}</Box>
                    </Box>
                  </React.Fragment>
                ))}

                <Divider sx={{ my: 3 }} />

                {/* Holiday Fields */}
                {holidayFields.map((field) => (
                  <React.Fragment key={field.label}>
                    <Box display="flex" justifyContent="space-between" py={0.5}>
                      <Typography fontSize={15} fontWeight={500}>
                        {field.label}
                      </Typography>
                      {renderPreviewValue(field.value)}
                    </Box>
                    {field.subFields && field.subFields.length > 0 && (
                      <Box mt={3}>
                        {field.subFields.map((sub, i) => (
                          <Box
                            key={i}
                            display="flex"
                            alignItems="flex-start"
                            pl={3}
                            gap={1}
                            mb={2}
                          >
                            <Box
                              sx={{
                                width: 6,
                                height: 6,
                                bgcolor: "#09bd71",
                                borderRadius: "2px",
                                mt: 0.5,
                              }}
                            />
                            <Box
                              display="flex"
                              justifyContent="space-between"
                              flex={1}
                            >
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                {sub.label}
                              </Typography>
                              {renderPreviewValue(sub.value, {
                                variant: "body2",
                              })}
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    )}
                    {field?.table && <CustomTable data={field?.tableData} />}
                    <Box
                      mt={1}
                      ml={3}
                      mb={2}
                      display="flex"
                      alignItems="flex-start"
                    >
                      <Box sx={{ width: "100%" }}>{field.data}</Box>
                    </Box>
                  </React.Fragment>
                ))}

                <Divider sx={{ my: 3 }} />

                {absenceFields.map((field) => (
                  <Box
                    sx={{
                      ...boxStyleSx,
                      pl: field.indent ? 3 : 0,
                    }}
                  >
                    {field.indent ? (
                      <Box
                        display="flex"
                        alignItems="flex-start"
                        flex={1}
                        gap={1}
                      >
                        <Box
                          sx={{
                            width: 6,
                            height: 6,
                            bgcolor: "#09bd71",
                            borderRadius: "2px",
                            mt: 0.5,
                          }}
                        />
                        <Box
                          display="flex"
                          justifyContent="space-between"
                          flex={1}
                        >
                          <Typography variant="body2" color="text.secondary">
                            {field.label}
                          </Typography>
                          {renderPreviewValue(field.value, {
                            variant: "body2",
                          })}
                        </Box>
                      </Box>
                    ) : (
                      <>
                        <Typography fontSize={15} fontWeight={600}>
                          {field.label}
                        </Typography>
                        {renderPreviewValue(field.value)}
                      </>
                    )}
                  </Box>
                ))}

                <Divider sx={{ my: 3 }} />

                {/* Penalty Fields */}
                {basicInfoData?.payment_based_on !== "Hours" && (
                  <>
                    {penaltyFields.map((field) => (
                      <>
                        <Box
                          sx={{
                            ...boxStyleSx,
                            pl: field.indent ? 3 : 0,
                          }}
                        >
                          {field.indent ? (
                            <Box
                              display="flex"
                              alignItems="flex-start"
                              flex={1}
                              gap={1}
                            >
                              <Box
                                sx={{
                                  width: 6,
                                  height: 6,
                                  bgcolor: "#09bd71",
                                  borderRadius: "2px",
                                  mt: 0.5,
                                }}
                              />
                              <Box
                                display="flex"
                                justifyContent="space-between"
                                flex={1}
                              >
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  {field.label}
                                </Typography>
                                {renderPreviewValue(field.value, {
                                  variant: "body2",
                                })}
                              </Box>
                            </Box>
                          ) : (
                            <>
                              <Typography fontSize={15} fontWeight={600}>
                                {field.label}
                              </Typography>
                              {renderPreviewValue(field.value)}
                            </>
                          )}
                        </Box>
                        <Box ml={3} display="flex" alignItems="flex-start">
                          <Box sx={{ width: "100%" }}>{field.data}</Box>
                        </Box>
                      </>
                    ))}
                  </>
                )}

                <Divider sx={{ my: 3 }} />

                {/* Break Penalty Fields */}
                {breakPenaltyFields.map((field) => (
                  <>
                    <Box
                      sx={{
                        ...boxStyleSx,
                        pl: field.indent ? 3 : 0,
                      }}
                    >
                      {field.indent ? (
                        <Box
                          display="flex"
                          alignItems="flex-start"
                          flex={1}
                          gap={1}
                        >
                          <Box
                            sx={{
                              width: 6,
                              height: 6,
                              bgcolor: "#09bd71",
                              borderRadius: "2px",
                              mt: 0.5,
                            }}
                          />
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            flex={1}
                          >
                            <Typography variant="body2" color="text.secondary">
                              {field.label}
                            </Typography>
                            {renderPreviewValue(field.value, {
                              variant: "body2",
                            })}
                          </Box>
                        </Box>
                      ) : (
                        <>
                          <Typography fontSize={15} fontWeight={600}>
                            {field.label}
                          </Typography>
                          {renderPreviewValue(field.value)}
                        </>
                      )}
                    </Box>
                    <Box ml={3} display="flex" alignItems="flex-start">
                      <Box sx={{ width: "100%" }}>{field.data}</Box>
                    </Box>
                  </>
                ))}
                <Divider sx={{ my: 3 }} />

                {deductSalaryFields.map((field) => (
                  <>
                    <Box
                      sx={{
                        ...boxStyleSx,
                        pl: field.indent ? 3 : 0,
                      }}
                    >
                      {field.indent ? (
                        <Box
                          display="flex"
                          alignItems="flex-start"
                          flex={1}
                          gap={1}
                        >
                          <Box
                            sx={{
                              width: 6,
                              height: 6,
                              bgcolor: "#09bd71",
                              borderRadius: "2px",
                              mt: 0.5,
                            }}
                          />
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            flex={1}
                          >
                            <Typography variant="body2" color="text.secondary">
                              {field.label}
                            </Typography>
                            {renderPreviewValue(field.value, {
                              variant: "body2",
                            })}
                          </Box>
                        </Box>
                      ) : (
                        <>
                          <Typography fontSize={15} fontWeight={600}>
                            {field.label}
                          </Typography>
                          {renderPreviewValue(field.value)}
                        </>
                      )}
                    </Box>
                    <Box ml={3} display="flex" alignItems="flex-start">
                      <Box sx={{ width: "100%" }}>{field.data}</Box>
                    </Box>
                  </>
                ))}
                <Divider sx={{ my: 3 }} />

                {leaveToAbsentConversionFields.map((field) => (
                  <>
                    <Box
                      sx={{
                        ...boxStyleSx,
                        pl: field.indent ? 3 : 0,
                      }}
                    >
                      {field.indent ? (
                        <Box
                          display="flex"
                          alignItems="flex-start"
                          flex={1}
                          gap={1}
                        >
                          <Box
                            sx={{
                              width: 6,
                              height: 6,
                              bgcolor: "#09bd71",
                              borderRadius: "2px",
                              mt: 0.5,
                            }}
                          />
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            flex={1}
                          >
                            <Typography variant="body2" color="text.secondary">
                              {field.label}
                            </Typography>
                            {renderPreviewValue(field.value, {
                              variant: "body2",
                            })}
                          </Box>
                        </Box>
                      ) : (
                        <>
                          <Typography fontSize={15} fontWeight={600}>
                            {field.label}
                          </Typography>
                          {renderPreviewValue(field.value)}
                        </>
                      )}
                    </Box>
                    <Box ml={3} display="flex" alignItems="flex-start">
                      <Box sx={{ width: "100%" }}>{field.data}</Box>
                    </Box>
                  </>
                ))}
                <Divider sx={{ my: 3 }} />

                {adjustmentFields.map((field, index) => (
                  <React.Fragment key={field.label}>
                    <Box
                      sx={{
                        ...boxStyleSx,
                        pl: field.indent ? 3 : 0,
                      }}
                    >
                      {field.indent ? (
                        <Box
                          display="flex"
                          alignItems="flex-start"
                          flex={1}
                          gap={1}
                        >
                          <Box
                            sx={{
                              width: 6,
                              height: 6,
                              bgcolor: "#09bd71",
                              borderRadius: "2px",
                              mt: 0.5,
                            }}
                          />
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            flex={1}
                          >
                            <Typography variant="body2" color="text.secondary">
                              {field.label}
                            </Typography>
                            {renderPreviewValue(field.value, {
                              variant: "body2",
                            })}
                          </Box>
                        </Box>
                      ) : (
                        <>
                          <Typography fontSize={15} fontWeight={600}>
                            {field.label}
                          </Typography>
                          {renderPreviewValue(field.value)}
                        </>
                      )}
                    </Box>
                    {field.subFields && field.subFields.length > 0 && (
                      <Box mt={3}>
                        {field.subFields.map((sub, subIndex) => (
                          <Box
                            key={subIndex}
                            display="flex"
                            alignItems="flex-start"
                            pl={3}
                            gap={1}
                            mb={2}
                          >
                            <Box
                              sx={{
                                width: 6,
                                height: 6,
                                bgcolor: "#09bd71",
                                borderRadius: "2px",
                                mt: 0.5,
                              }}
                            />
                            <Box
                              display="flex"
                              justifyContent="space-between"
                              flex={1}
                            >
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                {sub.label}
                              </Typography>
                              {renderPreviewValue(sub.value, {
                                variant: "body2",
                              })}
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    )}
                    {field.data && (
                      <Box ml={3} mt={2} display="flex" alignItems="flex-start">
                        <Box sx={{ width: "100%" }}>{field.data}</Box>
                      </Box>
                    )}
                    {index < adjustmentFields.length - 1 && (
                      <Divider sx={{ mt: 2 }} />
                    )}
                  </React.Fragment>
                ))}
              </CardContent>
            </Card>

            {/* Create Button */}
            {!isPreview && (
              <Box
                sx={{
                  ml: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Box>
                  <CustomButton
                    actionName="Prev"
                    typeName="button"
                    actionFuntion={() => {
                      handleBack(3);
                    }}
                  />
                </Box>
                <Box>
                  <CustomButton
                    actionName={
                      isCreateScreen
                        ? "Create"
                        : isEditScreen
                          ? "Update"
                          : "Clone"
                    }
                    typeName="submit"
                    disableAction={watch("button_loader")}
                  />
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      </Box>

      <Mui.Dialog
        open={openDialogConfimation}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
          }
          handleDeactivateDialogBox();
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            width: 650,
            maxWidth: "100%",
            borderRadius: 2,
          },
        }}
      >
        <Mui.DialogTitle id="alert-dialog-title">
          Update Shift Category
          <IconButton
            aria-label="close"
            onClick={handleDeactivateDialogBox}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Close />
          </IconButton>
        </Mui.DialogTitle>
        <Mui.Divider />

        <Mui.DialogContent>
          <Mui.DialogContentText id="alert-dialog-description">
            Updating this shift category will affect historical records,
            including attendance, overtime, and penalties. Do you want to
            proceed with these changes?
          </Mui.DialogContentText>
        </Mui.DialogContent>

        <Mui.DialogActions sx={{ mr: 2, mb: 1 }}>
          <CustomButtonWithBorder
            actionName={"Cancel"}
            actionFuntion={handleDeactivateDialogBox}
          />

          <CustomButtonWithBorder
            actionName={"Confirm"}
            actionFuntion={() => {
              updateShiftCategory(formValues);
            }}
            disableAction={openDialogConfimation && buttonLoader ? true : false}
            handleColor={true}
          />
        </Mui.DialogActions>
      </Mui.Dialog>
    </>
  );
};
